<div>Select the files to upload</div>
<div style="padding-top: 10px; margin-left: -15px;">
      <angular-file-uploader
            [config]="afuConfig">
      </angular-file-uploader>
</div>
<!-- this is just to test-->
<app-east-coast-2></app-east-coast-2>
<div>
</div>
<!-- this is just to test-->
<div style="padding-top:40px;" class="row">
      <div class="col-lg-12">
            <button class="btn btn-primary float-left" (click)="OnBackClick($event)">Back</button>
            <button class="btn btn-primary float-right" (click)="onClick1($event)">Next</button>
      </div>
</div>